import { Component } from '@headless-workspace/typings';

export const BreadcrumbSection: Component = () => {
    return (
        <section id={'product-list-breadcrumb'} className={'flex flex-row px-1 py-0.75'}>
            <div className={'w-full bg-background-skeleton'}>Breadcrumb</div>
        </section>
    );
};
